import i18next from "i18next";
import Prismic from "prismic-javascript";
import { Document } from "prismic-javascript/d.ts/documents";
import ResolvedApi from "prismic-javascript/d.ts/ResolvedApi";

import environment from "../environment";

export interface IDocument<IData> extends Document {
  data: IData;
}

let api: Promise<ResolvedApi> | ResolvedApi | null = null;
const requests: { [key: string]: Promise<Document> } = {};

export const fetchPrismic = async <T>(
  id: string,
  type: string,
  options: { graphQuery: string } | {} = {}
): Promise<IDocument<T> | null> => {
  const language = i18next.language === "en" ? "en-gb" : "fr-fr";

  try {
    if (!api) {
      api = Prismic.api(environment.CMS.ENDPOINT, {});
    }
    api = await api;

    const key =
      id + ";" + type + ";" + language + ";" + JSON.stringify(options);

    if (requests[key]) {
      return requests[key];
    }

    requests[key] = api.getByUID(type, id, {
      ...options,
      lang: language,
    });

    const document = await requests[key];

    return document;
  } catch (e) {
    return null;
  }
};
